import { apiClient } from '_app'
import { ApiResponse, DocumentDto, DocumentTypeDto, OcrReparseDto, OcrUploadDto } from 'dtos'
import { DocumentsParameters } from 'parameters'
import { URIQuery } from 'utils'

export const getOCRUploadedFiles = (parameters: DocumentsParameters) =>
  apiClient.get<ApiResponse<DocumentDto[]>>(`/api/ocr` + URIQuery({ ...parameters })).then(({ data }) => data)

export const acceptOCRDocument = (values: DocumentDto) =>
  apiClient.post('/api/ocr/accept', values).then(response => response.data)

export const getDocuments = (documentGuid: string, parameters: DocumentsParameters) =>
  apiClient.get<ApiResponse<DocumentDto[]>>(`/api/ocr/${documentGuid}/documents`).then(response => response.data)

export const deleteOCRDocument = (documentGuid: string) =>
  apiClient.delete<ApiResponse<null>>(`/api/ocr/${encodeURIComponent(documentGuid)}`).then(() => {})

export const verifyOCRDocument = (values: DocumentDto) =>
  apiClient.put<ApiResponse<DocumentDto>>('/api/ocr/verify').then(response => response.data)

export const uploadFiles = (dto: OcrUploadDto) => {
  const data = new FormData()

  dto.files?.forEach((x, index) => {
    data.append(`files`, x)
  })

  return apiClient({
    data,
    // headers: { 'Content-Type': 'multipart/form-data' },
    method: 'post',
    url: '/api/ocr'
  }).then(response => response.data)
}

export const getOCRDocument = (vehicleDocumentGuid: string) =>
  apiClient.get<ApiResponse<DocumentDto>>(`/api/ocr/${vehicleDocumentGuid}`).then(response => response.data)

export const getPDFDocument = (documentGuid: string) =>
  apiClient
    .get(`/api/ocr/${encodeURIComponent(documentGuid)}/file`, {
      responseType: 'blob'
    })
    .then(response => response.data)

export const uploadOCRDocument = (documentId: string, values: DocumentDto) => {
  const formData = new FormData()
  formData.append('documentFile', values.documentFile!)

  return apiClient.post<ApiResponse<DocumentDto>>(`/api/ocr/${documentId}`, formData).then(response => response.data)
}

export const getDocumentTypes = () =>
  apiClient.get<ApiResponse<DocumentTypeDto[]>>('/api/ocr/document-types').then(response => response.data)

export const reparseOCRDocument = (values: OcrReparseDto) =>
  apiClient.put<ApiResponse<DocumentDto>>('/api/ocr', values).then(response => response.data)

export const checkDuplicateVIN = (vin: string) =>
  apiClient
    .get<ApiResponse<boolean>>(`/api/ocr/check-duplicate-vin`, {
      params: { vin }
    })
    .then(response => response.data)

export const checkDuplicateSignedStatementOfConformity = (vin: string) =>
  apiClient
    .get<ApiResponse<boolean>>(`/api/ocr/check-duplicate-signed-statement-of-conformity`, {
      params: { vin }
    })
    .then(response => response.data)
